<template>
  <section :class="$style.wrapper">
    <OkanekoSorryImage :class="$style.wrapper__image" />
    <h3 :class="$style.wrapper__title">アプローチできるユーザーがいません</h3>
    <p v-if="$slots.default" :class="$style.wrapper__description">
      <slot />
    </p>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import OkanekoSorryImage from '@/assets/images/okaneko-sorry.svg?component'

export default defineComponent({
  name: 'KarteEmptyUserList',
  components: {
    OkanekoSorryImage,
  },
})
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__image {
    width: 120px;
    height: 120px;
  }

  &__title {
    color: $color-text-and-object-accent-primary;
    font-size: 18px;
    font-weight: bold;
    line-height: 32px;

    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__description {
    color: $color-text-and-object-medium-emphasis;
    font-size: 12px;
    line-height: 20px;
    text-align: center;

    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }
}
</style>
